/** Server clock: every response with `server_now` updates the offset, so
 *  timers count from the server's time, not from the device clock. */
let offsetMs = 0

export const serverClock = {
  /** Current server time in ms. */
  now(): number {
    return Date.now() + offsetMs
  },
  offset(): number {
    return offsetMs
  },
  /** Records the server time of a response received at `receivedAt` (device ms). */
  observe(serverNow: string | undefined, receivedAt = Date.now()): void {
    if (!serverNow) return
    const t = Date.parse(serverNow)
    if (!Number.isNaN(t)) offsetMs = t - receivedAt
  },
  /** Milliseconds left until an ISO moment by the server clock (≥ 0). */
  left(iso: string | null | undefined): number {
    if (!iso) return 0
    const t = Date.parse(iso)
    return Number.isNaN(t) ? 0 : Math.max(0, t - serverClock.now())
  },
  reset(): void {
    offsetMs = 0
  },
}
